import gql from 'graphql-tag';
import { GROUP_FRAGMENT, NOTEBOOK_FRAGMENT, SUBJECT_FRAGMENT, TRACKER_FRAGMENT } from './fragments';

export const notebookTemplatesQuery = gql`
  query NotebookTemplatesQuery {
    notebookTemplates {
      id
      name
    }
  }
`;

export const notebooksQuery = gql`
  query NotebooksQuery($input: NotebooksQueryInput!) {
    notebooks(input: $input) {
      ...NotebookFields
    }
  }
  ${NOTEBOOK_FRAGMENT}
`;

// TODO: use NotebookFragment -- but it wasn't working
// inlined it for now.
export const editNotebookMutation = gql`
  mutation EditNotebookMutation($input: EditNotebookInput!) {
    editNotebook(input: $input) {
      notebook {
        id
        name
        isDemo
        isArchived
        createdAt
      }
      errors {
        path
        message
      }
    }
  }
`;

export const createNotebookMutation = gql`
  mutation CreateNotebookMutation($input: CreateNotebookInput!) {
    createNotebook(input: $input) {
      errors {
        message
      }
      notebook {
        ...NotebookFields
      }
    }
  }
  ${NOTEBOOK_FRAGMENT}
`;

export const deleteNotebookMutation = gql`
  mutation DeleteNotebookMutation($id: ID!) {
    deleteNotebook(id: $id) {
      errors {
        path
        message
      }
    }
  }
`;

export const selectedNotebookQuery = gql`
  query SelectedNotebook($id: ID!) {
    notebook(id: $id) {
      ...NotebookFields
      # TODO: This should probably be in notebook fields
      # but creates an error on the notebooks query
      ownerMember {
        id
      }
      subjects {
        ...SubjectFields
      }
      ungroupedSubjects {
        ...SubjectFields
        trackers {
          ...TrackerFields
        }
      }
      trackers {
        ...TrackerFields
      }
      groups {
        ...GroupFields
        trackers {
          ...TrackerFields
        }
        subjects {
          ...SubjectFields
        }
      }
    }
  }
  ${NOTEBOOK_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const notebookQuery = gql`
  query NotebookQuery($id: ID!) {
    notebook(id: $id) {
      ...NotebookFields
      subjects {
        ...SubjectFields
      }
      ungroupedSubjects {
        ...SubjectFields
      }
      trackers {
        ...TrackerFields
      }
      groups {
        ...GroupFields
        trackers {
          ...TrackerFields
        }
        subjects {
          ...SubjectFields
        }
      }
    }
  }
  ${NOTEBOOK_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const notebookSubjectsAndTrackersQuery = gql`
  query NotebookSubjectsAndTrackersQuery($notebookId: ID!) {
    notebook(id: $notebookId) {
      ...NotebookFields
      subjects {
        ...SubjectFields
      }
      trackers {
        ...TrackerFields
      }
    }
  }
  ${NOTEBOOK_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const inviteMemberToNotebookMutation = gql`
  mutation InviteMemberToNotebookMutation($input: InviteMemberToNotebookInput!) {
    inviteMemberToNotebook(input: $input) {
      notebookMember {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

export const removeMemberFromNotebookMutation = gql`
  mutation RemoveMemberFromNotebookMutation($input: RemoveMemberFromNotebookInput!) {
    removeMemberFromNotebook(input: $input) {
      notebookMember {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

export const notebookMembersQuery = gql`
  query NotebookMembersQuery($input: NotebookMembersInput!) {
    notebookMembers(input: $input) {
      id
      member {
        id
        displayName
        user {
          id
        }
      }
      roleType
      membershipStatus
    }
  }
`;
